module.exports = {
      id: "daily-crossword-usage",
      viewBox: "0 0 220 220",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#daily-crossword",
      toString: function () {
        return this.url;
      }
    }